import React from 'react';
import GTMScript from 'components/GTMScript';
import TutoringSelfServeView from 'coaching/components/TutoringSelfServeView/TutoringSelfServeView';
import { PlainRoute } from 'react-router';
import CoachingStripeContainer from 'coaching/components/CoachingStripeContainer';
// @ts-ignore
import { promiseTelemetry } from 'lib/telemetry';
// @ts-ignore
import { configureRollbar } from 'utils/setupErrorLogging';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  route: PlainRoute;
};

export default function TutoringSelfServeContainer(props: Props) {
  React.useEffect(() => {
    // we want rollbar in this context even if the user is unauthed
    if (!CurrentUser.isSignedIn()) {
      promiseTelemetry().then(() => configureRollbar({ id: -1 }));
    }
  }, []);

  return (
    <React.Fragment>
      <GTMScript />
      <CoachingStripeContainer>
        <TutoringSelfServeView route={props.route} />
      </CoachingStripeContainer>
    </React.Fragment>
  );
}

